import { useEffect, useState, useMemo, useRef, useDeferredValue } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../../context/MyContext';
import '../../../../css/custom-scrollbar.css';
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import { Base_Url, shipmentList, shipmentallList, deleteShipment, priceEstimator, shipmentlabel, bulkshipmentlabel, Url_For_View_Document, allwarehouseslist, addShipment } from '../../../../config/config';
import ViewAllShipment from '../../../../component/b2c/models/ViewAllShipment';
import ViewRateForwardShipment from '../../../../component/b2c/models/ViewRateForwordShipmet';
import TrackingSidePopup from '../../../pages/dashborad/TrackingSidePopup';
import UploadBulk from '../../../../component/b2c/models/UploadBulk';
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { FaList, FaHourglassHalf, FaClipboardList, FaTruck, FaDownload, FaShippingFast, FaTimesCircle, FaEllipsisV, FaFileDownload, FaBox } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { FaShopify } from "react-icons/fa";
import { SiWoocommerce } from "react-icons/si";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { RxCross2 } from "react-icons/rx";
import { FaEye } from "react-icons/fa";
import { FaTrash, FaCopy } from "react-icons/fa";
import { TbRoute } from "react-icons/tb";
import { SiZoho } from "react-icons/si";
import {
  HiOutlineEye,
  HiOutlineDocumentDuplicate,
  HiOutlineRocketLaunch,
  HiOutlineXCircle,
  HiOutlinePrinter,
  HiOutlineDocumentText,
  HiChevronRight,
} from "react-icons/hi2";
import { createPortal } from 'react-dom';
import { FaDotCircle } from "react-icons/fa";
import AddShipmentPopup from '../forword/forwordShipment'

// ⚡ Sanitize shipments:
// 1. Pending (PD) orders NEVER have an AWB (waybill) - they are unshipped.
// 2. No two orders should EVER replicate/share the same AWB number. If a duplicate AWB appears,
//    only the manifested/shipped order keeps it, and the duplicate clone has waybill set to null.
const sanitizeShipmentList = (list) => {
  if (!Array.isArray(list)) return [];
  const seenWaybills = new Map();

  return list.map(item => {
    if (!item) return item;

    const rawStatus = String(item.status || item.order_status || item.current_status || '').toLowerCase().trim();
    const isPending = rawStatus.includes('pending') || rawStatus === 'pd';

    let cleanWaybill = item.waybill || item.awb_number || item.awb || null;
    if (isPending && cleanWaybill) {
      cleanWaybill = null;
    }

    if (cleanWaybill) {
      const wbStr = String(cleanWaybill).trim();
      if (seenWaybills.has(wbStr)) {
        cleanWaybill = null;
      } else {
        seenWaybills.set(wbStr, item.order_id);
      }
    }

    return {
      ...item,
      waybill: cleanWaybill,
      awb: cleanWaybill,
      awb_number: cleanWaybill,
    };
  });
};

// ⚡ Shipments cache (stale-while-revalidate): pehle cached data turant dikhao, phir background me fresh data lao
const SHIPMENT_CACHE_PREFIX = 'b2c_all_shipments_cache_';
const memoryShipmentCache = {};
const readShipmentCache = (cusId) => {
  const key = SHIPMENT_CACHE_PREFIX + (cusId || '');
  if (memoryShipmentCache[key]) return sanitizeShipmentList(memoryShipmentCache[key]);
  try {
    const rawSession = sessionStorage.getItem(key);
    if (rawSession) {
      const parsed = JSON.parse(rawSession);
      if (Array.isArray(parsed) && parsed.length > 0) {
        const sanitized = sanitizeShipmentList(parsed);
        memoryShipmentCache[key] = sanitized;
        return sanitized;
      }
    }
  } catch (e) { }
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : null;
    if (Array.isArray(parsed) && parsed.length > 0) {
      const sanitized = sanitizeShipmentList(parsed);
      memoryShipmentCache[key] = sanitized;
      return sanitized;
    }
  } catch (e) { /* ignore corrupt cache */ }
  return null;
};
const writeShipmentCache = (cusId, data) => {
  const key = SHIPMENT_CACHE_PREFIX + (cusId || '');
  const cleanData = sanitizeShipmentList(data);
  memoryShipmentCache[key] = cleanData;
  try { sessionStorage.setItem(key, JSON.stringify(cleanData)); } catch (e) { }
  try { localStorage.setItem(key, JSON.stringify(cleanData)); } catch (e) { /* storage full - memory & session cache still works */ }
};

// ⚡ Ek hi waqt pe same API do baar na chale (fast remount / multiple refresh calls share one request)
const inFlightShipmentRequests = {};
const requestAllShipments = (token, cusId, forceFresh = false) => {
  const key = cusId || '';
  if (forceFresh) {
    delete inFlightShipmentRequests[key];
  }
  if (inFlightShipmentRequests[key]) return inFlightShipmentRequests[key];
  const url = forceFresh
    ? `${Base_Url}${shipmentallList}?_cb=${Date.now()}`
    : `${Base_Url}${shipmentallList}`;
  const p = fetch(url, {
    method: 'GET',
    cache: forceFresh ? 'no-store' : 'default',
    headers: {
      token: token || localStorage.getItem('token') || '',
      cus_id: cusId || localStorage.getItem('cus_id') || '',
      'Content-Type': 'application/json',
      ...(forceFresh ? { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' } : {})
    },
  })
    .then(res => res.json())
    .finally(() => { delete inFlightShipmentRequests[key]; });
  inFlightShipmentRequests[key] = p;
  return p;
};

// ⚡ Warehouse list memory cache (popups turant ready)
const memoryWarehouseCache = {};

// ⚡ Search index: har row ka lowercase text ek baar banta hai, har keystroke pe dobara nahi
const searchIndexCache = new WeakMap();
const getRowSearchText = (row) => {
  let text = searchIndexCache.get(row);
  if (text === undefined) {
    text = Object.values(row)
      .filter(value => value !== null && value !== undefined)
      .map(value => value.toString().toLowerCase())
      .join('\u0001');
    searchIndexCache.set(row, text);
  }
  return text;
};

// ⚡ 19-digit standard Order ID generator (YYYYMMDDHHmmss + 5-digit random)
const generateStandardOrderId = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const ts = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const rand = Math.floor(10000 + Math.random() * 90000);
  return `${ts}${rand}`;
};

// ⚡ Purge any stale local cloned orders from previous automatic clones
try {
  localStorage.removeItem('b2c_local_cloned_orders');
} catch (e) { }

const AllShipment = () => {
  const [allData, setAllData] = useState(() => {
    try { localStorage.removeItem('b2c_local_cloned_orders'); } catch (e) { }
    const cached = readShipmentCache(localStorage.getItem('cus_id')) || [];
    return sanitizeShipmentList(cached);
  });
  const allDataRef = useRef(allData);
  allDataRef.current = allData;
  const isCloningRef = useRef(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isloading, isSetLoading] = useState(false);
  const [isMobileCardView, setIsMobileCardView] = useState(false);

  const [activeTab, setActiveTab] = useState('all orders');
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 15;

  const [selectedRowsForShip, setSelectedRowsForShip] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [selectedShipment, setSelectedShipment] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpenForShip, setIsPopupOpenForShip] = useState(false);

  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [actionMenuPos, setActionMenuPos] = useState({ top: 0, left: 0 });

  const [wareHouseList, setWareHouseList] = useState([]);

  // Add Shipment drawer
  const [isAddShipmentPopupOpen, setIsAddShipmentPopupOpen] = useState(false);

  // Upload Bulk popup
  const [uploadBulkPopupOpen, setUploadBulkPopupOpen] = useState(false);

  // Tracking side popup (opened from the info icon in Order ID & AWB column)
  const [isTrackingPopupOpen, setIsTrackingPopupOpen] = useState(false);
  const [trackingSearchTerm, setTrackingSearchTerm] = useState('');

  // Hover states for tooltips
  const [addressHover, setAddressHover] = useState({ id: null, x: 0, y: 0, above: false, data: null });
  const [statusHover, setStatusHover] = useState({ id: null, label: '', x: 0, y: 0, above: false });
  const [typeHover, setTypeHover] = useState({ id: null, label: '', x: 0, y: 0, above: false });
  const [customerHover, setCustomerHover] = useState({ id: null, x: 0, y: 0, above: false, data: null });
  const [productHover, setProductHover] = useState({ id: null, x: 0, y: 0, above: false, data: null });

  const { isDarkMode, isToggleSidebar, setorderId,setIsToggleSidebar } = useMyContext();
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const navigateForTrack = useNavigate();

  useEffect(() => {
    const checkScreen = () => setIsMobileCardView(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    fetchAllShipments();
    fetchWareHouseList();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openActionMenu !== null && !e.target.closest('.action-dropdown-menu') && !e.target.closest('.action-dropdown-trigger')) {
        setOpenActionMenu(null);
      }
    };
    const handleScrollOrResize = () => setOpenActionMenu(null);
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScrollOrResize, true);
    window.addEventListener('resize', handleScrollOrResize);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScrollOrResize, true);
      window.removeEventListener('resize', handleScrollOrResize);
    };
  }, [openActionMenu]);

  const fetchAllShipments = async (forceFresh = false) => {
    // Agar data pehle se dikh raha hai (cache) to full-page loader mat dikhao, chupchap refresh karo
    const showLoader = allDataRef.current.length === 0;
    try {
      if (showLoader) {
        setIsPageLoading(true);
      }

      const curToken = token || localStorage.getItem('token') || '';
      const curCusId = cusid || localStorage.getItem('cus_id') || '';

      const result = await requestAllShipments(curToken, curCusId, forceFresh);
      const freshData = Array.isArray(result?.data) ? result.data : [];

      // Sanitize: ensure no duplicate AWBs and no pending orders with fake AWBs
      const sanitized = sanitizeShipmentList(freshData);

      // Agar koi very recent order (created in last 60 seconds) server response me abhi tak include nahi hua,
      // to use retain karo taaki order disappear/flicker na kare
      const recentLocalOrders = (allDataRef.current || []).filter(item => {
        if (!item?.created_at) return false;
        const diffMs = Date.now() - new Date(item.created_at).getTime();
        const isRecent = diffMs >= 0 && diffMs < 60000;
        const inServer = sanitized.some(s => String(s.order_id) === String(item.order_id));
        return isRecent && !inServer;
      });

      const combined = [...recentLocalOrders, ...sanitized];

      // ⚡ Sort orders by date descending so the newest orders are always at the top!
      const merged = combined.sort((a, b) => {
        const tA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tB - tA;
      });

      setAllData(merged);
      writeShipmentCache(curCusId, merged);
    } catch (err) {
      toast.error("Failed to load shipments");
    } finally {
      setIsPageLoading(false);
    }
  };

  const fetchWareHouseList = async () => {
    if (memoryWarehouseCache[cusid || '']) setWareHouseList(memoryWarehouseCache[cusid || '']);
    try {
      const response = await fetch(Base_Url + allwarehouseslist, {
        method: 'GET',
        headers: { token: token || '', cus_id: cusid || '', 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = (data?.data || []).map(warehouse => ({
        value: warehouse.id,
        label: warehouse.name,
        pincode: warehouse.pincode
      }));
      setWareHouseList(transformedData);
      memoryWarehouseCache[cusid || ''] = transformedData;
    } catch (error) {
      console.error('Error fetching warehouse list:', error);
    }
  };

  const isTransitShipment = (item) => {
    if (!item) return false;
    const rawStatus = item.status || item.order_status || item.shipment_status || item.current_status || '';
    const s = String(rawStatus).toLowerCase().trim();
    if (!s) return false;
    return (
      s.includes('transit') ||
      s === 'it' ||
      s.includes('left_origin') ||
      s.includes('left origin') ||
      s.includes('reach_destination') ||
      s.includes('reach destination') ||
      s.includes('dispatched') ||
      s.includes('shipped')
    );
  };

  const tabMatches = (item, tabKey) => {
    if (tabKey === 'all orders') return true;
    if (tabKey === 'Add Shipment list' || tabKey === 'pending') return item.status?.toLowerCase().includes('pending');
    if (tabKey === 'process order') return item.status?.toLowerCase().includes('pickup') || item.status?.toLowerCase().includes('scheduled');
    if (tabKey === 'manifest list') return item.status?.toLowerCase() === 'manifested';
    if (tabKey === 'delivered') return item.status?.toLowerCase().includes('delivered');
    if (tabKey === 'failed') return item.status?.toLowerCase().includes('failed') || item.status?.toLowerCase().includes('cancel');
    if (tabKey === 'out for pickup') return item.status?.toLowerCase() === 'out for pickup' || item.status?.toLowerCase() === 'pickup';
    if (tabKey === 'in transit') return isTransitShipment(item);
    if (tabKey === 'out for delivery') return item.status?.toLowerCase().includes('out for delivery') || item.status?.toLowerCase().includes('ofd');
    if (tabKey === 'shopify') return item.partner?.toLowerCase() === 'shopify';
    if (tabKey === 'woocommerce') return item.partner?.toLowerCase() === 'woocommerce';
    if (tabKey === 'zoho') return item.partner?.toLowerCase() === 'zoho';
    return false;
  };

  // ⚡ Tab counts sirf data change hone par ek baar calculate (har hover/render par nahi)
  const tabCounts = useMemo(() => {
    const keys = ['all orders', 'Add Shipment list', 'process order', 'out for pickup', 'in transit', 'out for delivery', 'manifest list', 'delivered', 'failed', 'shopify', 'woocommerce', 'zoho'];
    const counts = {};
    keys.forEach(k => { counts[k] = 0; });
    allData.forEach(item => { keys.forEach(k => { if (tabMatches(item, k)) counts[k] += 1; }); });
    return counts;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allData]);

  const getTabCount = (tabKey) => {
    if (tabCounts[tabKey] !== undefined) return tabCounts[tabKey];
    return allData.filter(item => tabMatches(item, tabKey)).length;
  };

  // ⚡ Input turant update hota hai, heavy filtering thoda baad (typing smooth rahegi)
  const deferredSearchTerm = useDeferredValue(searchTerm);

  const filteredData = useMemo(() => {
    let data = [...allData];
    switch (activeTab) {
      case 'Add Shipment list':
      case 'pending':
        data = data.filter(item => item.status?.toLowerCase().includes('pending')); break;
      case 'process order':
        data = data.filter(item => item.status?.toLowerCase().includes('pickup') || item.status?.toLowerCase().includes('scheduled')); break;
      case 'manifest list':
        data = data.filter(item => item.status?.toLowerCase() === 'manifested'); break;
      case 'delivered':
        data = data.filter(item => item.status?.toLowerCase().includes('delivered')); break;
      case 'failed':
        data = data.filter(item => item.status?.toLowerCase().includes('failed') || item.status?.toLowerCase().includes('cancel')); break;
      case 'out for pickup':
        data = data.filter(item => item.status?.toLowerCase() === 'out for pickup' || item.status?.toLowerCase() === 'pickup'); break;
      case 'in transit':
        data = data.filter(item => isTransitShipment(item)); break;
      case 'out for delivery':
        data = data.filter(item => item.status?.toLowerCase().includes('out for delivery') || item.status?.toLowerCase().includes('ofd')); break;
      case 'shopify':
        data = data.filter(item => item.partner?.toLowerCase() === 'shopify'); break;
      case 'woocommerce':
        data = data.filter(item => item.partner?.toLowerCase() === 'woocommerce'); break;
      case 'zoho':
        data = data.filter(item => item.partner?.toLowerCase() === 'zoho'); break;
      default: break;
    }
    if (deferredSearchTerm.trim()) {
      const term = deferredSearchTerm.toLowerCase();
      data = data.filter(row => getRowSearchText(row).includes(term));
    }
    return data;
  }, [allData, activeTab, deferredSearchTerm]);

  const paginatedData = filteredData.slice((currentPage - 1) * limit, currentPage * limit);
  const totalPages = Math.ceil(filteredData.length / limit);

  useEffect(() => setCurrentPage(1), [activeTab, searchTerm]);

  const handleRowSelectForShip = (orderId, fullRow) => {
    if (selectedRowsForShip.includes(orderId)) {
      setSelectedRowsForShip(prev => prev.filter(id => id !== orderId));
      setSelectedRowsData(prev => prev.filter(row => row.order_id !== orderId));
    } else {
      setSelectedRowsForShip(prev => [...prev, orderId]);
      setSelectedRowsData(prev => [...prev, fullRow]);
    }
  };

  const handleSelectAllForShip = (checked) => {
    if (checked) {
      const pendingRows = paginatedData.filter(row => row.status?.toLowerCase().includes('pending'));
      setSelectedRowsForShip(pendingRows.map(row => row.order_id));
      setSelectedRowsData(pendingRows);
    } else {
      setSelectedRowsForShip([]);
      setSelectedRowsData([]);
    }
  };

  const handleRowSelectForLabel = (orderId) => {
    setSelectedRows(prev => prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]);
  };

  const handleSelectAllForLabel = (checked) => {
    if (checked) setSelectedRows(paginatedData.map(row => row.order_id));
    else setSelectedRows([]);
  };

  const handleBulkShipNow = async () => {
    if (selectedRowsData.length === 0) { toast.error("Please select at least one order to ship"); return; }
    const totals = selectedRowsData.reduce((acc, row) => ({
      length: acc.length + parseFloat(row.length || 0),
      width: acc.width + parseFloat(row.shipment_width || 0),
      height: acc.height + parseFloat(row.shipment_height || 0),
      weight: acc.weight + parseFloat(row.weight || 0),
      cod_amount: acc.cod_amount + parseFloat(row.cod_amount || 0)
    }), { length: 0, width: 0, height: 0, weight: 0, cod_amount: 0 });

    const pincodeCount = {};
    selectedRowsData.forEach(row => { const pin = row.pin; if (pin) pincodeCount[pin] = (pincodeCount[pin] || 0) + 1; });
    const mostCommonPincode = Object.keys(pincodeCount).reduce((a, b) => pincodeCount[a] > pincodeCount[b] ? a : b, '');

    const requestBody = {
      from_pincode: selectedRowsData[0].pickup_pin_code,
      to_pincode: mostCommonPincode,
      length: totals.length, width: totals.width, height: totals.height, weight: totals.weight,
      shipment_type: "Forward", declared_value: "",
      payment_mode: selectedRowsData[0].payment_mode,
      cod_amount: totals.cod_amount.toString()
    };

    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: { 'Content-Type': 'application/json', token, cus_id: cusid },
      });
      if (response.data.status === "success") {
        const enrichedBulkShipment = { ...response.data, bulk_order: true, selected_orders: selectedRowsData.map(r => r.order_id), total_orders: selectedRowsData.length, bulk_totals: totals, most_common_pincode: mostCommonPincode, selectedRowsData };
        setSelectedShipment(enrichedBulkShipment);
        setIsPopupOpenForShip(true);
        setSelectedRowsForShip([]);
        setSelectedRowsData([]);
        fetchAllShipments();
      } else { toast.error(response.data.message || "Something went wrong"); }
    } catch (error) {
      toast.error(error?.response?.data?.messages?.error || error.message || "Something Went Wrong!");
    } finally { setIsPageLoading(false); }
  };

  const handleDownload = async () => {
    if (selectedRows.length === 0) return toast.error("No orders selected");
    isSetLoading(true); setIsPageLoading(true);
    try {
      const response = await fetch(Base_Url + bulkshipmentlabel, {
        method: 'POST',
        headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_ids: selectedRows }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS" && data.DownloadLink) {
        window.open(Url_For_View_Document + data.DownloadLink, "_blank");
        toast.success("Bulk labels downloaded successfully!");
        fetchAllShipments();
      } else { toast.error(data.message || "Download failed"); }
    } catch (error) { toast.error("Download failed"); }
    finally { isSetLoading(false); setIsPageLoading(false); }
  };

  const handleViewClick = (row) => { setSelectedShipment(row); setIsPopupOpen(true); };
  const handleClick = (orderID) => { setorderId(orderID); navigateForTrack("/shipments/tracking"); };

  const handleCancelOrder = async (orderId) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?', text: "Do you want to cancel this order?", icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#d33', confirmButtonText: 'Yes, cancel it!',
    });
    if (!confirmResult.isConfirmed) return;
    setIsPageLoading(true);
    try {
      const response = await fetch(`${Base_Url}${deleteShipment}/${orderId}`, {
        method: 'GET', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
      });
      setAllData(prev => prev.filter(item => String(item.order_id) !== String(orderId)));
      if (response.ok) {
        toast.success("Order canceled successfully!");
        fetchAllShipments();
      }
    } catch (error) { toast.error(error.message); }
    finally { setIsPageLoading(false); }
  };

  // ⚡ Jab user Add Shipment karega, table me turant instant show hoga bina refresh ke!
  const handleShipmentAdded = (newOrderId, formData, responseData) => {
    if (newOrderId || formData) {
      const curCusId = cusid || localStorage.getItem('cus_id') || '';
      const whs = (wareHouseList && wareHouseList.length > 0) ? wareHouseList : (memoryWarehouseCache[curCusId] || []);
      const wh = whs.find(w => String(w.value) === String(formData?.warehouse));
      const pickupCity = wh?.label?.split('-')?.[0]?.trim() || wh?.label || '';
      const orderIdStr = String(newOrderId || formData?.orderId || generateStandardOrderId());
      const nowStr = new Date().toISOString();

      const optimisticOrder = {
        order_id: orderIdStr,
        waybill: responseData?.data?.waybill || responseData?.waybill || null,
        awb: responseData?.data?.waybill || responseData?.waybill || null,
        awb_number: responseData?.data?.waybill || responseData?.waybill || null,
        first_name: formData?.firstName || '',
        last_name: formData?.lastName || '',
        phone: formData?.mobile || '',
        email: formData?.email || '',
        pickup_city: pickupCity,
        city: formData?.city || '',
        state: formData?.state || '',
        address: formData?.address || '',
        pincode: formData?.pincode || '',
        products_desc: formData?.productDes || 'General Goods',
        product_desc: formData?.productDes || 'General Goods',
        quantity: '1',
        weight: formData?.weight || 100,
        length: formData?.length || 10,
        width: formData?.width || 10,
        height: formData?.height || 10,
        total_amount: formData?.invoiceAmount || 0,
        payment_mode: (formData?.paymentMode || 'prepaid').toUpperCase(),
        cod_amount: formData?.codAmount || 0,
        status: 'pending',
        order_status: 'pending',
        created_at: nowStr,
      };

      setAllData(prev => {
        const withoutNew = (prev || []).filter(item => String(item.order_id) !== orderIdStr);
        const updated = [optimisticOrder, ...withoutNew];
        writeShipmentCache(curCusId, updated);
        return updated;
      });

      if (activeTab !== 'all orders' && activeTab !== 'Add Shipment list' && activeTab !== 'pending') {
        setActiveTab('all orders');
      }
      setCurrentPage(1);
    }

    fetchAllShipments(true);
    setTimeout(() => {
      fetchAllShipments(true);
    }, 1500);
  };

  const handleCloneOrder = async (row) => {
    if (!row || isCloningRef.current) return;
    isCloningRef.current = true;
    setIsPageLoading(true);
    const newOrderId = generateStandardOrderId();

    const curToken = token || localStorage.getItem('token') || '';
    const curCusId = cusid || localStorage.getItem('cus_id') || '';

    // ⚡ Hit B2C Add Shipment API (exact same API as Add Shipment)
    try {
      let b2cWhId = row.warehouse_id || row.warehouseId || row.wh_id;
      let whs = (wareHouseList && wareHouseList.length > 0) ? wareHouseList : (memoryWarehouseCache[curCusId] || []);

      if (!b2cWhId || !whs || whs.length === 0) {
        try {
          const whRes = await fetch(Base_Url + allwarehouseslist, {
            headers: { token: curToken, cus_id: curCusId, 'Content-Type': 'application/json' }
          });
          const whData = await whRes.json();
          whs = (whData?.data || whData?.warehouses || []).map(w => ({
            value: w.id || w.warehouse_id,
            label: w.name || w.warehouse_name || '',
            pincode: w.pincode || '',
            city: w.city || ''
          }));
          if (whs.length > 0) {
            setWareHouseList(whs);
            memoryWarehouseCache[curCusId] = whs;
          }
        } catch (e) { }
      }

      if (!b2cWhId && whs && whs.length > 0) {
        const pickupCity = String(row.pickup_city || row.pickup_location || '').toLowerCase().trim();
        const matched = whs.find(w =>
          (w.city && w.city.toLowerCase().trim() === pickupCity) ||
          (w.label && w.label.toLowerCase().trim().includes(pickupCity)) ||
          (row.pickup_pincode && String(w.pincode).trim() === String(row.pickup_pincode).trim())
        );
        b2cWhId = matched ? matched.value : whs[0].value;
      }
      b2cWhId = String(b2cWhId || '1');

      // ⚡ Sanitize Customer Name (both first & last name required by CodeIgniter backend)
      let rawFirst = (row.first_name || '').trim();
      let rawLast = (row.last_name || '').trim();
      if (!rawFirst && !rawLast) {
        const parts = (row.customer_name || row.name || 'Customer User').trim().split(/\s+/);
        rawFirst = parts[0] || 'Customer';
        rawLast = parts.slice(1).join(' ') || 'User';
      } else if (!rawLast) {
        const parts = rawFirst.split(/\s+/);
        if (parts.length > 1) {
          rawFirst = parts[0];
          rawLast = parts.slice(1).join(' ');
        } else {
          rawLast = rawFirst || 'User';
        }
      } else if (!rawFirst) {
        rawFirst = rawLast || 'Customer';
      }
      const safeFirst = rawFirst.replace(/[^a-zA-Z\s]/g, '').trim() || 'Customer';
      const safeLast = rawLast.replace(/[^a-zA-Z\s]/g, '').trim() || 'User';

      // ⚡ Sanitize Phone (10 digits required)
      let phone = String(row.phone || row.mobile || row.delivery_phone || '').replace(/[^0-9]/g, '');
      if (phone.length < 10) phone = '9876543210';
      if (phone.length > 10) phone = phone.slice(-10);

      // ⚡ Sanitize Address & Destination (Address requires min 10 chars)
      let dropAddress = (row.address || row.delivery_address || '').trim();
      if (dropAddress.length < 10) {
        dropAddress = `${dropAddress} ${row.city || ''} ${row.state || ''}`.trim();
        if (dropAddress.length < 10) {
          dropAddress = `${row.city || 'Delhi'} Delivery Address, Sector 62`;
        }
      }
      let dropPin = String(row.pin || row.pincode || row.delivery_pin || '110001').replace(/[^0-9]/g, '');
      if (dropPin.length !== 6) dropPin = '110001';
      let dropCity = (row.city || row.destination_city || 'Delhi').replace(/[^a-zA-Z\s]/g, '').trim() || 'Delhi';
      let dropState = (row.state || row.destination_state || 'Delhi').replace(/[^a-zA-Z\s]/g, '').trim() || 'Delhi';

      // ⚡ Payment & Product details
      const payMode = (row.payment_mode || 'prepaid').toLowerCase().includes('cod') ? 'cod' : 'prepaid';
      const totAmt = String(row.total_amount || row.declared_value || 100);
      const codAmt = payMode === 'cod' ? String(row.cod_amount || row.total_amount || 0) : '0';
      const prodDesc = (row.products_desc || row.product_desc || 'General Goods').trim();

      // ⚡ Dimensions (weight must be integer >= 50 gm)
      const safeLength = String(Math.max(1, Math.round(parseFloat(row.length || 10))));
      const safeWidth = String(Math.max(1, Math.round(parseFloat(row.shipment_width || row.width || 10))));
      const safeHeight = String(Math.max(1, Math.round(parseFloat(row.shipment_height || row.height || 10))));
      const safeWeight = String(Math.max(50, Math.round(parseFloat(row.weight || 500))));

      const requestBody = {
        order_id: newOrderId,
        customer: {
          first_name: safeFirst,
          last_name: safeLast,
          email: row.email || 'customer@gmail.com',
          phone: phone,
          address_type: "home",
        },
        droplocation: {
          address: dropAddress,
          city: dropCity,
          state: dropState,
          country: "India",
          pin: dropPin,
        },
        pickuplocation: {
          warehouse_id: b2cWhId
        },
        product: {
          order_id: newOrderId,
          product_desc: prodDesc,
          quantity: String(row.quantity || 1),
          total_amount: totAmt,
          cod_amount: codAmt,
          payment_mode: payMode,
          shipment_type: "Forward"
        },
        dimension: {
          length: safeLength,
          width: safeWidth,
          height: safeHeight,
          weight: safeWeight,
        },
      };

      const res = await axios.post(Base_Url + addShipment, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': curToken,
          'cus_id': curCusId,
        },
      });

      const isSuccess = res.data?.status === "SUCCESS" ||
        (res.status === 200 && res.data?.status !== "FAIL" && res.data?.status !== "ERROR" && !res.data?.error);

      if (isSuccess) {
        try { localStorage.removeItem('b2c_local_cloned_orders'); } catch (e) { }
        await fetchAllShipments(true);
        toast.success(`Order cloned with new Order ID #${newOrderId}!`);
      } else {
        const errorMsg = res.data?.message ||
          (res.data?.messages ? (typeof res.data.messages === 'object' ? Object.values(res.data.messages).join(' | ') : String(res.data.messages)) : "Failed to clone order on server");
        toast.error(errorMsg);
      }
    } catch (apiErr) {
      console.warn("B2C Clone API error:", apiErr);
      const serverMsg = apiErr.response?.data?.messages
        ? (typeof apiErr.response.data.messages === 'object'
            ? Object.values(apiErr.response.data.messages).join(' | ')
            : String(apiErr.response.data.messages))
        : (apiErr.response?.data?.message || apiErr.message || "Failed to clone order");
      toast.error(serverMsg);
    } finally {
      isCloningRef.current = false;
      setIsPageLoading(false);
    }
  };

  const handlePrintLabel = async (orderId) => {
    setIsPageLoading(true);
    try {
      const response = await fetch(`${Base_Url}${shipmentlabel}`, {
        method: 'POST', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: orderId }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS" && data?.DownloadLink) {
        window.open(Base_Url + data.DownloadLink, '_blank');
        toast.success("Label downloaded successfully!");
        fetchAllShipments();
      }
    } catch (error) { toast.error('API error: ' + error.message); }
    finally { setIsPageLoading(false); }
  };

  const handleDownloadPOD = (row) => {
    if (!row?.epod_file) {
      toast.error("POD not available for this order yet");
      return;
    }
    window.open(Url_For_View_Document + row.epod_file, "_blank");
    toast.success("POD downloaded successfully!");
  };

  const copyToClipboard = (text, label) => { navigator.clipboard.writeText(text); toast.success(`${label} copied!`); };

  // Opens the side tracking popup for a specific order (info icon click)
  const handleOpenTrackingPopup = (orderId) => {
    setTrackingSearchTerm(orderId || '');
    setIsTrackingPopupOpen(true);
  };

  const getStatusStyle = (status) => {
    if (!status) return 'bg-gray-100 text-gray-600';
    const s = status.toLowerCase();
    if (s.includes('failed') || s.includes('cancel')) return 'bg-red-100 text-red-700';
    if (s.includes('pending')) return 'bg-yellow-100 text-yellow-700';
    return 'bg-emerald-100 text-emerald-700';
  };

  // Mobile status pill colors (glassy, gradient friendly)
  const getMobileStatusStyle = (status) => {
    if (!status) return 'bg-gray-500/15 text-gray-600 dark:text-gray-300 border-gray-400/30';
    const s = status.toLowerCase();
    if (s.includes('cancel')) return 'bg-red-500/15 text-red-600 dark:text-red-300 border-red-400/40';
    if (s.includes('failed')) return 'bg-black/80 text-white border-black/60 dark:bg-red-500/20 dark:text-red-300 dark:border-red-400/40';
    if (s.includes('pending')) return 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-400/40';
    if (s.includes('delivered')) return 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-400/40';
    if (s.includes('out for delivery') || s.includes('ofd')) return 'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-400/40';
    if (s.includes('out for pickup') || s === 'pickup') return 'bg-cyan-500/15 text-cyan-700 dark:text-cyan-300 border-cyan-400/40';
    if (s.includes('manifest')) return 'bg-purple-500/15 text-purple-700 dark:text-purple-300 border-purple-400/40';
    if (s.includes('transit')) return 'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300 border-indigo-400/40';
    if (s.includes('process') || s.includes('scheduled')) return 'bg-orange-500/15 text-orange-700 dark:text-orange-300 border-orange-400/40';
    return 'bg-gray-500/15 text-gray-600 dark:text-gray-300 border-gray-400/30';
  };

  // Colorful modern badge config per status (used for the desktop Status column)
  const getStatusBadgeConfig = (status) => {
    if (!status) return {
      badgeClass: 'border-2 border-gray-300 bg-gray-50 text-gray-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300',
      dotClass: 'bg-gray-400',
      label: '—'
    };
    const s = status.toLowerCase();

    if (s.includes('cancel')) return {
      badgeClass: 'border-2 border-red-500 bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300 shadow-sm shadow-red-500/10',
      dotClass: 'bg-red-500',
      label: 'CN'
    };
    if (s.includes('failed')) return {
      badgeClass: 'border-2 border-rose-600 bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 shadow-sm shadow-rose-500/10',
      dotClass: 'bg-rose-600',
      label: 'FL'
    };
    if (s.includes('pending')) return {
      badgeClass: 'border-2 border-amber-400 bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300 shadow-sm shadow-amber-500/15',
      dotClass: 'bg-amber-500',
      label: 'PD'
    };
    if (s.includes('delivered')) return {
      badgeClass: 'border-2 border-emerald-500 bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300 shadow-sm shadow-emerald-500/15',
      dotClass: 'bg-emerald-500',
      label: 'DL'
    };
    if (s.includes('out for delivery') || s.includes('ofd')) return {
      badgeClass: 'border-2 border-sky-500 bg-sky-50 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300 shadow-sm shadow-sky-500/15',
      dotClass: 'bg-sky-500',
      label: 'OFD'
    };
    if (s.includes('out for pickup') || s === 'pickup' || s === 'ofp') return {
      badgeClass: 'border-2 border-teal-500 bg-teal-50 text-teal-800 dark:bg-teal-950/40 dark:text-teal-300 shadow-sm shadow-teal-500/15',
      dotClass: 'bg-teal-500',
      label: 'OFP'
    };
    if (s.includes('manifest') || s === 'mf') return {
      badgeClass: 'border-2 border-purple-500 bg-purple-50 text-purple-800 dark:bg-purple-950/40 dark:text-purple-300 shadow-sm shadow-purple-500/15',
      dotClass: 'bg-purple-500',
      label: 'MF'
    };
    if (s.includes('transit') || s === 'it') return {
      badgeClass: 'border-2 border-indigo-500 bg-indigo-50 text-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-300 shadow-sm shadow-indigo-500/15',
      dotClass: 'bg-indigo-500',
      label: 'IT'
    };
    if (s.includes('process') || s.includes('scheduled')) return {
      badgeClass: 'border-2 border-blue-500 bg-blue-50 text-blue-800 dark:bg-blue-950/40 dark:text-blue-300 shadow-sm shadow-blue-500/15',
      dotClass: 'bg-blue-500',
      label: 'PR'
    };

    return {
      badgeClass: 'border-2 border-gray-400 bg-gray-50 text-gray-800 dark:bg-gray-800 dark:text-gray-300',
      dotClass: 'bg-gray-400',
      label: status.slice(0, 3).toUpperCase()
    };
  };

  const getStatusBadgeColor = (status) => getStatusBadgeConfig(status).badgeClass;

  // Deterministic colorful gradient for customer avatar (per customer, not all same/black)
  const avatarGradients = [
    'from-pink-500 to-rose-500',
    'from-orange-500 to-amber-500',
    'from-lime-500 to-green-500',
    'from-emerald-500 to-teal-500',
    'from-cyan-500 to-sky-500',
    'from-blue-500 to-indigo-500',
    'from-violet-500 to-purple-500',
    'from-fuchsia-500 to-pink-500',
    'from-red-500 to-orange-500',
    'from-teal-500 to-cyan-500',
    'from-indigo-500 to-blue-500',
    'from-purple-500 to-fuchsia-500',
  ];
  const getAvatarGradient = (seed) => {
    const str = (seed || 'U').toString();
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarGradients.length;
    return avatarGradients[index];
  };

  const handleShipNow = async (data) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const requestBody = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      address: data.address,
      product_desc: data.products_desc,
      phone: data.phone,
      city: data.city,
      state: data.state,
      country: "India",
      payment_mode: data.payment_mode,
      total_amount: data.total_amount,
      address_type: "home",
      length: data.length,
      width: data.shipment_width,
      height: data.shipment_height,
      from_pincode: data.pickup_pin_code,
      to_pincode: data.pin,
      cod_amount: data.cod_amount,
      quantity: "1",
      weight: data.weight,
      shipment_type: "Forward",
      order_id: data.order_id
    };
    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        const enrichedShipment = { ...response.data, order_id: data.order_id };
        handleViewClickForShip(enrichedShipment);
        fetchAllShipments();
      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
      }
    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleViewClickForShip = (shipment) => {
    setSelectedShipment(shipment);
    setIsPopupOpenForShip(true);
  };

  const tabs = [
    { key: "all orders", label: "All Orders", icon: <FaList />, activeGradient: "from-indigo-600 via-indigo-600 to-violet-600 text-white shadow-lg shadow-indigo-500/30 ring-1 ring-white/30" },
    { key: "Add Shipment list", label: "Pending", icon: <FaTruck />, activeGradient: "from-amber-500 via-amber-600 to-orange-500 text-white shadow-lg shadow-amber-500/30 ring-1 ring-white/30" },
    { key: "process order", label: "Process", icon: <FaClipboardList />, activeGradient: "from-blue-600 via-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/30 ring-1 ring-white/30" },
    { key: "out for pickup", label: "Out for Pickup", icon: <FaTruck />, activeGradient: "from-teal-600 via-teal-600 to-cyan-600 text-white shadow-lg shadow-teal-500/30 ring-1 ring-white/30" },
    { key: "in transit", label: "In Transit", icon: <FaShippingFast />, activeGradient: "from-indigo-600 via-indigo-700 to-purple-600 text-white shadow-lg shadow-indigo-500/30 ring-1 ring-white/30" },
    { key: "out for delivery", label: "Out for Delivery", icon: <FaTruck />, activeGradient: "from-sky-600 via-sky-600 to-blue-600 text-white shadow-lg shadow-sky-500/30 ring-1 ring-white/30" },
    { key: "manifest list", label: "Manifest", icon: <FaHourglassHalf />, activeGradient: "from-purple-600 via-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/30 ring-1 ring-white/30" },
    { key: "delivered", label: "Delivered", icon: <FaTruck />, activeGradient: "from-emerald-600 via-emerald-600 to-teal-600 text-white shadow-lg shadow-emerald-500/30 ring-1 ring-white/30" },
    { key: "failed", label: "Failed", icon: <FaTimesCircle />, activeGradient: "from-rose-600 via-rose-600 to-red-600 text-white shadow-lg shadow-rose-500/30 ring-1 ring-white/30" },
    { key: "shopify", label: "Shopify", icon: <FaShopify />, activeGradient: "from-emerald-600 via-green-600 to-teal-600 text-white shadow-lg shadow-emerald-500/30 ring-1 ring-white/30" },
    { key: "woocommerce", label: "WooCommerce", icon: <SiWoocommerce />, activeGradient: "from-purple-600 via-violet-600 to-indigo-600 text-white shadow-lg shadow-purple-500/30 ring-1 ring-white/30" },
    { key: "zoho", label: "Zoho", icon: <SiZoho />, activeGradient: "from-amber-600 via-orange-600 to-red-600 text-white shadow-lg shadow-amber-500/30 ring-1 ring-white/30" },
  ];

  // Address hover handlers
  const handleAddressEnter = (e, row) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 200;
    setAddressHover({
      id: row.order_id,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above,
      data: row
    });
  };
const UploadBulkViewClick = () => setUploadBulkPopupOpen(true);
const handleCloseUploadBulk = () => setUploadBulkPopupOpen(false);
  const handleAddressLeave = () => {
    setAddressHover({ id: null, x: 0, y: 0, above: false, data: null });
  };

  // Status hover handlers
  const handleStatusEnter = (e, rowId, label) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 60;
    setStatusHover({
      id: rowId,
      label,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above
    });
  };

  const handleStatusLeave = () => setStatusHover({ id: null, label: '', x: 0, y: 0, above: false });

  // Type hover handlers
  const handleTypeEnter = (e, rowId, label) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 60;
    setTypeHover({
      id: rowId,
      label,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above
    });
  };

  const handleTypeLeave = () => setTypeHover({ id: null, label: '', x: 0, y: 0, above: false });

  // Customer Info hover handlers
  const handleCustomerEnter = (e, row) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 200;
    setCustomerHover({
      id: row.order_id,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above,
      data: row
    });
  };

  const handleCustomerLeave = () => {
    setCustomerHover({ id: null, x: 0, y: 0, above: false, data: null });
  };

  // Product Details hover handlers
  const handleProductEnter = (e, row) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 200;
    setProductHover({
      id: row.order_id,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above,
      data: row
    });
  };

  const handleProductLeave = () => {
    setProductHover({ id: null, x: 0, y: 0, above: false, data: null });
  };

  // Address Tooltip Portal
  const AddressTooltip = () => {
    if (!addressHover.id || !addressHover.data) return null;
    const row = addressHover.data;
    const pickupCity = row.pickup_city || '—';
    const pickupAddress = row.pickup_address || '';
    const destCity = row.city || '—';
    const destAddress = row.address || '';
    const pickupPhone = row.pickup_phone || '';
    const destPhone = row.delivery_phone || '';

    const style = {
      position: 'fixed',
      left: addressHover.x,
      top: addressHover.above ? 'auto' : addressHover.y - window.scrollY + 6,
      bottom: addressHover.above ? window.innerHeight - (addressHover.y - window.scrollY) + 6 : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };

    return createPortal(
      <div style={style} className="flex flex-col items-center drop-shadow-xl">
        {!addressHover.above && (
          <div className="w-2.5 h-2.5 bg-white dark:bg-slate-900 border-l border-t border-gray-200 dark:border-indigo-500/40 rotate-45 -mb-1.5 z-10" />
        )}
        <div className="bg-white dark:bg-slate-900 text-gray-800 dark:text-white text-[10px] font-medium p-3 rounded-xl shadow-2xl border border-gray-200 dark:border-indigo-500/40 max-w-[300px] w-full">
          <div className="space-y-2">
            <div>
              <div className="flex items-center gap-1.5 text-[9px] font-extrabold text-emerald-600 dark:text-emerald-400 uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-emerald-500 ring-2 ring-emerald-200 dark:ring-emerald-950 inline-block shrink-0" />
                ORIGIN
              </div>
              <div className="font-bold text-[12px] text-gray-900 dark:text-gray-100 mt-0.5">{pickupCity}</div>
              <div className="text-gray-600 dark:text-gray-300 text-[9.5px] leading-relaxed break-words">{pickupAddress}</div>
              {pickupPhone && <div className="text-gray-500 dark:text-gray-400 text-[9px] font-mono mt-0.5">📞 {pickupPhone}</div>}
            </div>
            <div className="border-t border-gray-100 dark:border-gray-800 pt-1.5">
              <div className="flex items-center gap-1.5 text-[9px] font-extrabold text-rose-600 dark:text-rose-400 uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-rose-500 ring-2 ring-rose-200 dark:ring-rose-950 inline-block shrink-0" />
                DESTINATION
              </div>
              <div className="font-bold text-[12px] text-gray-900 dark:text-gray-100 mt-0.5">{destCity}</div>
              <div className="text-gray-600 dark:text-gray-300 text-[9.5px] leading-relaxed break-words">{destAddress}</div>
              {destPhone && <div className="text-gray-500 dark:text-gray-400 text-[9px] font-mono mt-0.5">📞 {destPhone}</div>}
            </div>
          </div>
        </div>
        {addressHover.above && (
          <div className="w-2.5 h-2.5 bg-white dark:bg-slate-900 border-r border-b border-gray-200 dark:border-indigo-500/40 rotate-45 -mt-1.5 z-10" />
        )}
      </div>,
      document.body
    );
  };

  // Status Tooltip Portal
  const StatusTooltip = () => {
    if (!statusHover.id) return null;
    const style = {
      position: 'fixed',
      left: statusHover.x,
      top: statusHover.above ? 'auto' : statusHover.y - window.scrollY,
      bottom: statusHover.above ? window.innerHeight - (statusHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };
    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!statusHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-gray-900 text-white text-[10px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">{statusHover.label}</div>
        {statusHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  // Type Tooltip Portal
  const TypeTooltip = () => {
    if (!typeHover.id) return null;
    const style = {
      position: 'fixed',
      left: typeHover.x,
      top: typeHover.above ? 'auto' : typeHover.y - window.scrollY,
      bottom: typeHover.above ? window.innerHeight - (typeHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };
    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!typeHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-gray-900 text-white text-[10px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">{typeHover.label}</div>
        {typeHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  // Customer Info Tooltip Portal
  const CustomerTooltip = () => {
    if (!customerHover.id || !customerHover.data) return null;
    const row = customerHover.data;
    const fullName = `${row.first_name || ''} ${row.last_name || ''}`.trim() || '—';
    const phone = row.phone || '—';
    const email = row.email || '';
    const addressType = row.address_type || '';
    const partner = row.partner || '';

    const style = {
      position: 'fixed',
      left: customerHover.x,
      top: customerHover.above ? 'auto' : customerHover.y - window.scrollY + 6,
      bottom: customerHover.above ? window.innerHeight - (customerHover.y - window.scrollY) + 6 : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };

    return createPortal(
      <div style={style} className="flex flex-col items-center drop-shadow-xl">
        {!customerHover.above && (
          <div className="w-2.5 h-2.5 bg-white dark:bg-slate-900 border-l border-t border-gray-200 dark:border-indigo-500/40 rotate-45 -mb-1.5 z-10" />
        )}
        <div className="bg-white dark:bg-slate-900 text-gray-800 dark:text-white text-[10px] font-medium p-3 rounded-xl shadow-2xl border border-gray-200 dark:border-indigo-500/40 max-w-[290px] w-full">
          <div className="space-y-2">
            <div>
              <div className="flex items-center gap-1.5 text-[9px] font-extrabold text-indigo-600 dark:text-indigo-400 uppercase tracking-wide">
                <span className="w-2 h-2 rounded-full bg-indigo-500 ring-2 ring-indigo-200 dark:ring-indigo-950 inline-block shrink-0" />
                Customer Info
              </div>
              <div className="font-bold text-[12px] text-gray-900 dark:text-gray-100 mt-0.5 capitalize">{fullName}</div>
              {phone && <div className="text-gray-600 dark:text-gray-300 text-[9.5px] font-mono mt-0.5">📞 {phone}</div>}
              {email && <div className="text-gray-500 dark:text-gray-400 text-[9px] break-words mt-0.5">✉️ {email}</div>}
            </div>
            {(addressType || partner) && (
              <div className="border-t border-gray-100 dark:border-gray-800 pt-1.5 space-y-0.5">
                {addressType && (
                  <div className="text-gray-500 dark:text-gray-400 text-[9px]">Type: <span className="font-bold text-gray-700 dark:text-gray-200 capitalize">{addressType}</span></div>
                )}
                {partner && (
                  <div className="text-gray-500 dark:text-gray-400 text-[9px]">Channel: <span className="font-bold text-indigo-600 dark:text-indigo-300 capitalize">{partner}</span></div>
                )}
              </div>
            )}
          </div>
        </div>
        {customerHover.above && (
          <div className="w-2.5 h-2.5 bg-white dark:bg-slate-900 border-r border-b border-gray-200 dark:border-indigo-500/40 rotate-45 -mt-1.5 z-10" />
        )}
      </div>,
      document.body
    );
  };

  // Product Details Tooltip Portal
  const ProductTooltip = () => {
    if (!productHover.id || !productHover.data) return null;
    const row = productHover.data;
    const productDesc = row.products_desc || '—';
    const quantity = row.quantity || '—';
    const weight = row.weight || '—';
    const dims = `${row.length || 0}×${row.shipment_width || 0}×${row.shipment_height || 0}`;
    const declaredValue = row.declared_value || row.total_amount || '';

    const style = {
      position: 'fixed',
      left: productHover.x,
      top: productHover.above ? 'auto' : productHover.y - window.scrollY + 6,
      bottom: productHover.above ? window.innerHeight - (productHover.y - window.scrollY) + 6 : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };

    return createPortal(
      <div style={style} className="flex flex-col items-center drop-shadow-xl">
        {!productHover.above && (
          <div className="w-2.5 h-2.5 bg-white dark:bg-slate-900 border-l border-t border-gray-200 dark:border-indigo-500/40 rotate-45 -mb-1.5 z-10" />
        )}
        <div className="bg-white dark:bg-slate-900 text-gray-800 dark:text-white text-[10px] font-medium p-3 rounded-xl shadow-2xl border border-gray-200 dark:border-indigo-500/40 max-w-[290px] w-full">
          <div className="space-y-2">
            <div>
              <div className="flex items-center gap-1.5 text-[9px] font-extrabold text-purple-600 dark:text-purple-400 uppercase tracking-wide">
                <span className="w-2 h-2 rounded-full bg-purple-500 ring-2 ring-purple-200 dark:ring-purple-950 inline-block shrink-0" />
                Product Details
              </div>
              <div className="font-bold text-[12px] text-gray-900 dark:text-gray-100 mt-0.5 break-words">{productDesc}</div>
            </div>
            <div className="border-t border-gray-100 dark:border-gray-800 pt-1.5 space-y-0.5">
              <div className="text-gray-500 dark:text-gray-400 text-[9px]">Quantity: <span className="font-bold text-gray-800 dark:text-gray-200">{quantity}</span></div>
              <div className="text-gray-500 dark:text-gray-400 text-[9px]">Weight: <span className="font-bold text-gray-800 dark:text-gray-200">{weight}g</span></div>
              <div className="text-gray-500 dark:text-gray-400 text-[9px]">Dimensions: <span className="font-bold text-gray-800 dark:text-gray-200 font-mono">{dims} cm</span></div>
              {declaredValue && <div className="text-gray-500 dark:text-gray-400 text-[9px]">Value: <span className="font-extrabold text-emerald-600 dark:text-emerald-400">₹{declaredValue}</span></div>}
            </div>
          </div>
        </div>
        {productHover.above && (
          <div className="w-2.5 h-2.5 bg-white dark:bg-slate-900 border-r border-b border-gray-200 dark:border-indigo-500/40 rotate-45 -mt-1.5 z-10" />
        )}
      </div>,
      document.body
    );
  };

  const handleActionMenuToggle = (e, orderId) => {
    e.stopPropagation();
    if (openActionMenu === orderId) {
      setOpenActionMenu(null);
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuWidth = 224;
    const gap = 6;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let left = rect.right - menuWidth;
    if (left < 10) left = 10;
    if (left + menuWidth > viewportWidth - 10) left = viewportWidth - menuWidth - 10;

    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    const openUpward = spaceBelow < 260 && spaceAbove > spaceBelow;

    if (openUpward) {
      setActionMenuPos({
        bottom: viewportHeight - rect.top + gap,
        top: 'auto',
        left,
        maxHeight: Math.max(160, Math.min(360, spaceAbove - gap - 12))
      });
    } else {
      setActionMenuPos({
        top: rect.bottom + gap,
        bottom: 'auto',
        left,
        maxHeight: Math.max(160, Math.min(360, spaceBelow - gap - 12))
      });
    }
    setOpenActionMenu(orderId);
  };
  const navigate = useNavigate();
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

      <NavBar />
      <div className="flex flex-1 overflow-hidden">
         {/* ── Mobile backdrop: tap outside to close the drawer (md and up: not shown) ── */}
                 {isToggleSidebar && (
                   <div
                     className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                     onClick={() => setIsToggleSidebar(false)}
                   />
                 )}
       
                 <div
                   className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                 >
                   <Sidebar />
                 </div>

        <FullPageLoader isLoading={isPageLoading} message="Processing..." />

        <div className="flex-1 p-2 md:p-2 overflow-y-auto bg-gray-100 dark:bg-black custom-scrollbar min-w-0">
          {/* ================= MOBILE HEADER (only < md) ================= */}
          <div className="md:hidden mb-3">
            <div className="flex items-center justify-between mb-3">
              <h1 className="text-lg font-bold text-gray-800 dark:text-white">
                All Shipments
              </h1>
              <span className="text-[10px] font-semibold text-indigo-600 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-500/15 px-2.5 py-1 rounded-full border border-indigo-100 dark:border-indigo-500/30">
                {filteredData.length} orders
              </span>
            </div>

            {/* Search bar full width */}
            <div className="relative w-full mb-3">
              <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-indigo-300/70" size={18} />
              <input
                type="text"
                placeholder="Search Order ID, Name, Phone..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-11 pr-4 py-2.5 bg-white dark:bg-[#141425] border border-gray-200 dark:border-indigo-500/30 rounded-2xl focus:border-indigo-500 dark:focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/20 outline-none text-[13px] dark:text-white dark:placeholder-indigo-300/50 shadow-sm transition-all"
              />
            </div>

            {/* Two action buttons side by side */}
            <div className="flex gap-2">
              <button
                onClick={() => setIsAddShipmentPopupOpen(true)}
                className="flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white px-4 py-2.5 rounded-2xl flex items-center justify-center gap-2 font-semibold text-[13px] shadow-lg shadow-indigo-500/25 active:scale-[0.97] transition-transform"
              >
                <FaShippingFast size={14} /> Add Shipment
              </button>
              <button
                onClick={UploadBulkViewClick}
                className="flex-1 bg-white dark:bg-[#141425] text-gray-700 dark:text-indigo-200 border border-gray-200 dark:border-indigo-500/30 hover:bg-gray-50 dark:hover:bg-indigo-500/10 px-4 py-2.5 rounded-2xl flex items-center justify-center gap-2 font-semibold text-[13px] shadow-sm active:scale-[0.97] transition-transform"
              >
                <FaBox size={14} /> Upload Bulk
              </button>
            </div>
          </div>

          {/* ================= DESKTOP HEADER (md and up) ================= */}
          <div className='hidden md:flex w-full justify-between items-center mb-3'>
            <h1 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white">
              All Shipments
            </h1>
            <div className="flex gap-2 md:gap-3 items-start md:items-center">
              <button
                onClick={() => setIsAddShipmentPopupOpen(true)}
                className="bg-indigo-600 hover:bg-indigo-700 dark:bg-gradient-to-r dark:from-indigo-600 dark:to-purple-600 dark:hover:from-indigo-500 dark:hover:to-purple-500 dark:text-white dark:shadow-lg dark:shadow-indigo-900/50 text-white px-2 md:px-2 py-1.5 md:py-1.5 rounded-lg flex items-center gap-2 font-medium text-[12px] transition-all"
              >
                Add Shipment
              </button>

              <button
                onClick={UploadBulkViewClick}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300 dark:bg-black dark:text-white dark:border-indigo-500/40 dark:hover:bg-indigo-500/10 px-2 md:px-2 py-1.5 md:py-1.5 rounded-lg flex items-center gap-2 font-medium text-[12px] transition-all"
              >
                <FaBox size={12} /> Upload Bulk
              </button>

              <div className="relative w-full md:w-80 lg:w-96 flex-shrink-0">
                <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-indigo-300/70" size={18} />
                <input
                  type="text"
                  placeholder="Search by Order ID, Name, Phone..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-1.5 md:py-1.5 bg-white dark:bg-[#1a1a2e] border border-gray-300 dark:border-indigo-400/50 rounded-xl focus:border-blue-500 dark:focus:border-indigo-400 dark:focus:ring-2 dark:focus:ring-indigo-500/40 outline-none text-sm dark:text-white dark:placeholder-indigo-300/50 transition-all"
                />
              </div>
            </div>
          </div>

          {/* ================= TABS RIBBON — VIBRANT & COLORFUL ================= */}
          <div className="flex items-center gap-1.5 overflow-x-auto pb-1.5 scrollbar-hide mb-2">
            {tabs.map(tab => {
              const count = getTabCount(tab.key);
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[11.5px] font-bold transition-all duration-200 whitespace-nowrap shrink-0 cursor-pointer ${
                    isActive
                      ? `bg-gradient-to-r ${tab.activeGradient} scale-[1.03] shadow-md`
                      : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:border-indigo-300 hover:bg-gray-50 hover:text-gray-900 dark:hover:text-white shadow-2xs hover:-translate-y-0.5'
                  }`}
                >
                  <span className={`text-[11px] ${isActive ? 'text-white' : 'text-gray-400'}`}>{tab.icon}</span>
                  <span>{tab.label}</span>
                  <span className={`px-1.5 py-0.2 rounded-full text-[9px] font-extrabold ${
                    isActive ? 'bg-white/25 text-white backdrop-blur-xs' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'
                  }`}>
                    {count}
                  </span>
                </button>
              );
            })}
          </div>

          {((activeTab === 'Add Shipment list' || activeTab === 'pending') && selectedRowsForShip.length > 0) || selectedRows.length > 0 ? (
            <div className="mb-4 flex gap-2 md:gap-3 flex-wrap">
              {(activeTab === 'Add Shipment list' || activeTab === 'pending') && selectedRowsForShip.length > 0 && (
                <button
                  onClick={handleBulkShipNow}
                  className="bg-emerald-600 hover:bg-emerald-700 dark:bg-gradient-to-r dark:from-emerald-600 dark:to-teal-600 dark:hover:from-emerald-500 dark:hover:to-teal-500 dark:text-white dark:shadow-lg dark:shadow-emerald-900/40 text-white px-4 md:px-6 py-2 md:py-3 rounded-xl flex items-center gap-2 font-medium text-sm"
                >
                  <FaShippingFast /> Ship Now ({selectedRowsForShip.length})
                </button>
              )}
              {selectedRows.length > 0 && (
                <button
                  onClick={handleDownload}
                  disabled={isloading}
                  className="bg-purple-600 hover:bg-purple-700 dark:bg-gradient-to-r dark:from-indigo-600 dark:to-purple-600 dark:hover:from-indigo-500 dark:hover:to-purple-500 dark:text-white dark:shadow-lg dark:shadow-indigo-900/50 text-white px-4 md:px-6 py-2 md:py-3 rounded-xl flex items-center gap-2 font-medium text-sm disabled:opacity-70"
                >
                  {isloading ? "Processing..." : <><FaDownload /> Download Labels ({selectedRows.length})</>}
                </button>
              )}
            </div>
          ) : null}

          <style>{`
            @keyframes fadeSlideIn {
              from { opacity: 0; transform: translateY(10px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .row-animate { animation: fadeSlideIn 0.35s ease both; }
            tr.row-animate:hover td { background-color: rgba(99,102,241,0.04); transition: background 0.2s; }
            .scrollbar-hide::-webkit-scrollbar { display: none; }
            .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
            @keyframes cardIn {
              from { opacity: 0; transform: translateY(12px) scale(0.98); }
              to   { opacity: 1; transform: translateY(0) scale(1); }
            }
            .card-animate { animation: cardIn 0.3s ease both; }
            .mobile-glass {
              background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7));
              backdrop-filter: blur(12px);
              -webkit-backdrop-filter: blur(12px);
            }
            .dark .mobile-glass {
              background: linear-gradient(135deg, rgba(15,15,25,0.9), rgba(20,20,35,0.8));
              backdrop-filter: blur(12px);
              -webkit-backdrop-filter: blur(12px);
            }
            .mobile-action-btn {
              transition: all 0.2s ease;
            }
            .mobile-action-btn:active {
              transform: scale(0.94);
            }
          `}</style>

          {isMobileCardView ? (
            <div className="flex flex-col gap-4 pb-4">
              {paginatedData.length === 0 && (
                <div className="text-center py-16 text-gray-400 dark:text-indigo-300/60 bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-3xl border border-gray-200 dark:border-indigo-500/25 shadow-lg">
                  <FaBox className="mx-auto mb-3 text-4xl opacity-30" />
                  <p className="font-medium">No orders found</p>
                </div>
              )}
              {paginatedData.map((row, index) => {
                const isPending = row.status?.toLowerCase().includes('pending');
                const isTrackingDisabled = row.status?.toLowerCase() === "pending" || row.status?.toLowerCase() === "failed" || !row.waybill;
                const isFailed = row.status?.toLowerCase() === "failed";
                const isChecked = selectedRowsForShip.includes(row.order_id) || selectedRows.includes(row.order_id);

                return (
                  <div
                    key={row.order_id}
                    className={`card-animate relative rounded-3xl overflow-hidden transition-all duration-300
                      ${isChecked
                        ? 'ring-2 ring-indigo-500/60 shadow-lg shadow-indigo-500/20'
                        : 'shadow-md shadow-black/5 dark:shadow-indigo-900/20'
                      }`}
                    style={{ animationDelay: `${index * 50}ms` }}
                  >
                    {/* Glass background */}
                    <div className={`absolute inset-0 ${
                      isChecked
                        ? 'bg-gradient-to-br from-indigo-50 via-white to-purple-50 dark:from-indigo-950/60 dark:via-[#0d0d18] dark:to-purple-950/40'
                        : 'bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14]'
                    }`} />
                    
                    {/* Top accent line */}
                    <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${
                      isChecked ? 'from-indigo-500 via-purple-500 to-pink-500' : 'from-gray-200 via-gray-100 to-gray-200 dark:from-indigo-500/30 dark:via-purple-500/30 dark:to-pink-500/30'
                    }`} />

                    <div className="relative p-4">
                      {/* Header row */}
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex items-start gap-3">
                          <div className="relative mt-0.5">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => {
                                if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleRowSelectForShip(row.order_id, row);
                                else handleRowSelectForLabel(row.order_id);
                              }}
                              className="w-5 h-5 rounded-md accent-indigo-600 dark:accent-indigo-400 cursor-pointer"
                            />
                          </div>
                          <div>
                            <div className="flex flex-col items-start gap-1">
                              <div className="flex items-center gap-1.5">
                                <span
                                  onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                  className="font-bold text-sm text-indigo-600 dark:text-indigo-300 cursor-pointer active:scale-95 transition-transform hover:underline"
                                >
                                  #{row.order_id}
                                </span>
                                 <TbRoute
                                  className="cursor-pointer text-sky-500 hover:text-indigo-600 dark:hover:text-white transition-colors active:scale-95"
                                  size={16}
                                  onClick={() => handleOpenTrackingPopup(row.order_id)}
                                  title="Trace shipment"
                                />
                              </div>
                              {row.waybill && !String(row.status || '').toLowerCase().includes('pending') && String(row.status || '').toUpperCase() !== 'PD' && (
                                <button
                                  onClick={() => copyToClipboard(row.waybill, "AWB")}
                                  className="text-[10px] w-fit text-gray-500 dark:text-indigo-300/60 bg-gray-100 dark:bg-indigo-500/10 px-2 py-0.5 rounded-md active:scale-95 transition-transform"
                                >
                                  AWB: {row.waybill}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                        <span className={`px-2.5 py-1 text-[10px] font-bold rounded-full border ${getMobileStatusStyle(row.status)}`}>
                          {row.status}
                        </span>
                      </div>

                      {/* Customer + avatar */}
                      <div className="flex items-center gap-3 mb-3 p-2.5 rounded-2xl bg-gray-50/80 dark:bg-white/[0.03]">
                        <div className={`w-10 h-10 rounded-full flex-shrink-0 bg-gradient-to-br ${getAvatarGradient(row.order_id || `${row.first_name}${row.last_name}`)} flex items-center justify-center shadow-lg shadow-black/10`}>
                          <span className="text-white text-sm font-bold">
                            {((row.first_name || row.last_name)?.charAt(0) || 'U').toUpperCase()}
                          </span>
                        </div>
                        <div className="min-w-0 flex-1">
                          <div className="font-semibold text-sm text-gray-800 dark:text-gray-100 capitalize truncate">
                            {row.first_name} {row.last_name}
                          </div>
                          <div className="text-[11px] text-gray-400 dark:text-indigo-300/60">
                            {row.phone}
                          </div>
                        </div>
                        <div className="text-right flex-shrink-0">
                          <div className="font-bold text-sm text-gray-800 dark:text-gray-100">₹{row.total_amount}</div>
                          {row.payment_mode === 'cod' && (
                            <div className="text-[10px] font-medium text-orange-500 dark:text-orange-400">COD ₹{row.cod_amount}</div>
                          )}
                        </div>
                      </div>

                      {/* Route */}
                      <div className="flex items-center gap-2 mb-3 px-1">
                        <div className="flex flex-col items-center pt-0.5">
                          <FaDotCircle className="text-emerald-500 dark:text-emerald-400" size={7} />
                          <span className="w-px flex-1 border-l border-dashed border-gray-300 dark:border-indigo-400/40 my-0.5" style={{ minHeight: '16px' }} />
                          <span className="w-2 h-2 bg-rose-500 dark:bg-rose-400 rounded-full flex-shrink-0" />
                        </div>
                        <div className="flex-1 flex flex-col gap-2">
                          <div className="flex items-center justify-between">
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-200 truncate max-w-[140px]">
                              {row.pickup_city || '—'}
                            </span>
                            <span className="text-[10px] text-gray-400 dark:text-indigo-300/50">Origin</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-200 truncate max-w-[140px]">
                              {row.city || '—'}
                            </span>
                            <span className="text-[10px] text-gray-400 dark:text-indigo-300/50">Destination</span>
                          </div>
                        </div>
                      </div>

                      {/* Product + meta */}
                      <div className="grid grid-cols-2 gap-2 mb-3">
                        <div className="p-2.5 rounded-2xl bg-gray-50/80 dark:bg-white/[0.03]">
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 uppercase tracking-wide mb-0.5">Product</div>
                          <div className="text-xs font-medium text-gray-700 dark:text-gray-200 line-clamp-1">
                            {row.products_desc || '—'}
                          </div>
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 mt-0.5">
                            Qty: {row.quantity} · {row.weight}g
                          </div>
                        </div>
                        <div className="p-2.5 rounded-2xl bg-gray-50/80 dark:bg-white/[0.03]">
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 uppercase tracking-wide mb-0.5">Date &amp; Time</div>
                          <div className="text-xs font-semibold text-gray-700 dark:text-gray-200">
                            {row.created_at ? new Date(row.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                          </div>
                          {row.created_at && (
                            <div className="text-[10px] text-gray-400 dark:text-indigo-300/60 font-medium">
                              {new Date(row.created_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                          )}
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 mt-0.5">
                            {row.length}×{row.shipment_width}×{row.shipment_height} cm
                          </div>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex items-center gap-1.5 pt-2 border-t border-gray-100 dark:border-indigo-500/20">
                        <button
                          onClick={() => handleViewClick(row)}
                          className="mobile-action-btn flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 active:scale-95 text-white shadow-md shadow-indigo-500/25 text-xs font-bold transition-all duration-200"
                        >
                          <FaEye size={14} className="opacity-90" /> View
                        </button>
                        {(activeTab === 'Add Shipment list' || activeTab === 'pending') && isPending && (
                          <button
                            onClick={() => handleShipNow(row)}
                            className="mobile-action-btn flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-300 text-xs font-semibold"
                          >
                            <FaShippingFast size={13} /> Ship
                          </button>
                        )}
                        {(isPending || isFailed) && (
                          <button
                            onClick={() => handleCancelOrder(row.order_id)}
                            className="mobile-action-btn flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-red-50 dark:bg-red-500/10 text-red-500 dark:text-red-400 text-xs font-semibold"
                          >
                            <RxCross2 size={13} /> Cancel
                          </button>
                        )}
                        {!isPending && (
                          <button
                            onClick={() => handlePrintLabel(row.order_id)}
                            className="mobile-action-btn flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl bg-purple-50 dark:bg-purple-500/10 text-purple-600 dark:text-purple-300 text-xs font-semibold"
                          >
                            <FaDownload size={13} />
                          </button>
                        )}
                        <button
                          onClick={() => copyToClipboard(row.order_id, "Order ID")}
                          className="mobile-action-btn flex items-center justify-center p-2 rounded-xl bg-gray-50 dark:bg-white/[0.04] text-gray-400 dark:text-indigo-300/60"
                        >
                          <FaCopy size={13} />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            /* ================= DESKTOP TABLE — VIBRANT FLOATING CARD ROWS ================= */
            <div className="overflow-x-auto pb-4" style={{ overflow: 'visible' }}>
              <table className="w-full table-auto border-separate border-spacing-x-0 border-spacing-y-1.5 text-xs">
                <thead>
                  <tr className="text-slate-600 dark:text-slate-300">
                    <th className="py-2 px-3 w-8 text-center rounded-l-xl border-y border-l border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">
                      <input
                        type="checkbox"
                        checked={
                          (activeTab === 'Add Shipment list' || activeTab === 'pending')
                            ? selectedRowsForShip.length === paginatedData.length && paginatedData.length > 0
                            : selectedRows.length === paginatedData.length && paginatedData.length > 0
                        }
                        onChange={(e) => {
                          if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleSelectAllForShip(e.target.checked);
                          else handleSelectAllForLabel(e.target.checked);
                        }}
                        className="w-3.5 h-3.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer accent-indigo-600"
                      />
                    </th>
                    <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">ORDER ID &amp; AWB</th>
                    <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">CUSTOMER INFO</th>
                    <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">ORIGIN &amp; DESTINATION</th>
                    <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">PRODUCT DETAILS</th>
                    <th className="py-2 px-3 text-right text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">PAYMENT</th>
                    <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">STATUS</th>
                    <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">DATE</th>
                    <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap rounded-r-xl border-y border-r border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">ACTIONS</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length === 0 && (
                    <tr>
                      <td colSpan={9} className="py-10 text-center text-xs text-gray-500 bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm">
                        No orders found
                      </td>
                    </tr>
                  )}
                  {paginatedData.map((row, index) => {
                    const isChecked = selectedRowsForShip.includes(row.order_id) || selectedRows.includes(row.order_id);

                    const cellBg = isChecked
                      ? 'bg-slate-50/90 dark:bg-slate-800/80'
                      : 'bg-white dark:bg-[#111827] group-hover:bg-gray-50/50 dark:group-hover:bg-gray-800/60';
                    const cellBorder = isChecked
                      ? 'border-indigo-400 dark:border-indigo-500'
                      : 'border-gray-200/75 dark:border-gray-800 group-hover:border-gray-300 dark:group-hover:border-gray-700';

                    const fullStatus = row.status || '—';
                    const statusCfg = getStatusBadgeConfig(fullStatus);

                    return (
                      <tr
                        key={row.order_id}
                        className="group row-animate transition-all duration-200 shadow-xs hover:shadow-md hover:shadow-gray-200/70 dark:hover:shadow-black/50 hover:-translate-y-0.5"
                        style={{ animationDelay: `${index * 15}ms` }}
                      >
                        {/* Checkbox */}
                        <td className={`py-1.5 px-3 text-center align-middle rounded-l-2xl border-y border-l ${cellBorder} ${cellBg} transition-all`}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => {
                              if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleRowSelectForShip(row.order_id, row);
                              else handleRowSelectForLabel(row.order_id);
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer accent-indigo-600"
                          />
                        </td>

                        {/* Order ID & AWB */}
                        <td className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                          <div className="flex flex-col gap-0.5">
                            <div className="flex items-center gap-1.5">
                              <span
                                onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                title="Click to copy Order ID"
                                className="font-semibold text-[13px] text-blue-600 dark:text-blue-400 underline decoration-blue-200 hover:decoration-blue-500 hover:text-blue-700 cursor-pointer transition-colors tracking-tight"
                              >
                                {row.order_id}
                              </span>
                              <TbRoute
                                size={15}
                                className="cursor-pointer text-sky-500 hover:text-blue-600 hover:scale-125 transition-all shrink-0"
                                onClick={() => handleOpenTrackingPopup(row.order_id)}
                                title="Trace shipment"
                              />
                            </div>
                            {row.waybill && !String(row.status || '').toLowerCase().includes('pending') && String(row.status || '').toUpperCase() !== 'PD' ? (
                              <div
                                onClick={() => copyToClipboard(row.waybill, "AWB")}
                                title="Click to copy AWB"
                                className="text-[10px] font-mono text-gray-500 dark:text-gray-400 hover:text-blue-600 cursor-pointer inline-flex items-center gap-1 bg-gray-50 dark:bg-gray-800/80 hover:bg-gray-100 px-1.5 py-0.2 rounded border border-gray-200/80 dark:border-gray-700 w-fit transition-colors"
                              >
                                <span className="font-normal text-gray-400">AWB:</span>
                                <span className="font-medium text-gray-700 dark:text-gray-300">{row.waybill}</span>
                              </div>
                            ) : null}
                          </div>
                        </td>

                        {/* Customer Info */}
                        <td
                          className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all cursor-pointer`}
                          onMouseEnter={(e) => handleCustomerEnter(e, row)}
                          onMouseLeave={handleCustomerLeave}
                        >
                          <div className="flex items-center gap-2.5">
                            <div className={`w-7 h-7 rounded-full bg-gradient-to-tr ${getAvatarGradient(row.order_id || `${row.first_name}${row.last_name}`)} text-white text-[11px] font-bold flex items-center justify-center shrink-0 shadow-xs ring-2 ring-white dark:ring-gray-800`}>
                              {((row.first_name || row.last_name)?.charAt(0) || 'C').toUpperCase()}
                            </div>
                            <div className="min-w-0">
                              <div className="font-semibold text-gray-800 dark:text-gray-100 text-[12px] capitalize truncate max-w-[125px] group-hover:text-blue-600 transition-colors">
                                {row.first_name} {row.last_name}
                              </div>
                              <div className="text-[10px] font-mono text-gray-400 dark:text-gray-500 font-normal">
                                {row.phone}
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* Origin & Destination */}
                        <td
                          className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all cursor-pointer`}
                          onMouseEnter={(e) => handleAddressEnter(e, row)}
                          onMouseLeave={handleAddressLeave}
                        >
                          <div className="h-[42px] flex flex-col justify-between min-w-0 relative pl-5 py-1">
                            {/* Dotted vertical connector line — elongated & clearly visible */}
                            <div className="absolute left-[5px] top-[7px] bottom-[7px] w-px border-l-2 border-dotted border-gray-400 dark:border-gray-500" />
                            
                            {/* Origin */}
                            <div className="flex items-center gap-2 min-w-0 relative">
                              <span className="absolute -left-5 w-2.5 h-2.5 rounded-full bg-emerald-500 ring-2 ring-emerald-100 dark:ring-emerald-950/70 shrink-0" />
                              <span className="font-medium text-gray-800 dark:text-gray-200 text-[11.5px] truncate max-w-[130px] leading-snug">
                                {row.pickup_city || '—'}
                              </span>
                            </div>

                            {/* Destination */}
                            <div className="flex items-center gap-2 min-w-0 relative">
                              <span className="absolute -left-5 w-2.5 h-2.5 rounded-full bg-indigo-600 ring-2 ring-indigo-100 dark:ring-indigo-950/70 shrink-0" />
                              <span className="font-semibold text-indigo-600 dark:text-indigo-400 text-[11.5px] truncate max-w-[130px] leading-snug">
                                {row.city || '—'}
                              </span>
                            </div>
                          </div>
                        </td>

                        {/* Product Details */}
                        <td
                          className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all cursor-pointer`}
                          onMouseEnter={(e) => handleProductEnter(e, row)}
                          onMouseLeave={handleProductLeave}
                        >
                          <div className="font-semibold text-gray-800 dark:text-gray-100 text-[11.5px] truncate max-w-[125px] leading-tight capitalize">
                            {row.products_desc || '—'}
                          </div>
                          <div className="text-gray-500 dark:text-gray-400 text-[9.5px] font-normal mt-0.5 leading-tight">
                            Qty: <span className="font-semibold text-indigo-600 dark:text-indigo-400 bg-indigo-50/80 dark:bg-indigo-950/40 px-1 py-0.2 rounded">{row.quantity || 1}</span>
                            <span className="text-gray-300 dark:text-gray-600 mx-1">|</span>
                            <span>{row.weight || 0}g</span>
                          </div>
                          <div className="text-gray-400 dark:text-gray-500 text-[9px] font-mono mt-0.5 leading-tight">
                            {row.length || 0}×{row.shipment_width || 0}×{row.shipment_height || 0}
                          </div>
                        </td>

                        {/* Payment */}
                        <td className={`py-1.5 px-3 text-right align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                          <div className="font-bold text-gray-800 dark:text-gray-100 text-[13.5px] tracking-tight">
                            ₹{parseFloat(row.total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                          </div>
                          {row.payment_mode === 'cod' ? (
                            <div className="inline-flex items-center gap-1 text-[8.5px] font-bold text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-950/40 border border-amber-300/80 dark:border-amber-700/60 px-1.5 py-0.2 rounded-full uppercase tracking-wider mt-0.5">
                              COD: ₹{parseFloat(row.cod_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </div>
                          ) : (
                            <div className="inline-flex items-center gap-1 text-[8.5px] font-bold text-emerald-700 dark:text-emerald-300 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-300/80 dark:border-emerald-700/60 px-1.5 py-0.2 rounded-full uppercase tracking-wider mt-0.5">
                              PREPAID
                            </div>
                          )}
                        </td>

                        {/* Status */}
                        <td className={`py-1.5 px-3 text-center align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                          <span
                            className={`inline-flex items-center justify-center min-w-[38px] px-2.5 py-0.5 text-[10.5px] font-bold rounded-full cursor-default transition-all duration-150 hover:scale-105 shadow-xs ${statusCfg.badgeClass}`}
                            onMouseEnter={(e) => handleStatusEnter(e, row.order_id, fullStatus)}
                            onMouseLeave={handleStatusLeave}
                          >
                            {statusCfg.label}
                          </span>
                        </td>

                        {/* Date */}
                        <td className={`py-1.5 px-3 text-center align-middle whitespace-nowrap border-y ${cellBorder} ${cellBg} transition-all`}>
                          <div className="flex flex-col items-center">
                            <span className="font-semibold text-gray-700 dark:text-gray-200 text-[11.5px] leading-tight">
                              {row.created_at ? new Date(row.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                            </span>
                            {row.created_at && (
                              <span className="text-[9.5px] text-gray-400 dark:text-gray-500 font-mono font-normal mt-0.5">
                                {new Date(row.created_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }).toLowerCase()}
                              </span>
                            )}
                          </div>
                        </td>

                        {/* Actions */}
                        <td className={`py-1.5 px-3 text-center align-middle rounded-r-2xl border-y border-r ${cellBorder} ${cellBg} transition-all`}>
                          <button
                            onClick={(e) => handleActionMenuToggle(e, row.order_id)}
                            className="action-dropdown-trigger w-7 h-7 rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-gray-300 hover:bg-gray-50 text-gray-500 hover:text-gray-800 transition-all shadow-xs inline-flex items-center justify-center cursor-pointer active:scale-90"
                            title="Actions"
                          >
                            <FaEllipsisV size={11} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            /* ================= END DESKTOP TABLE ================= */
          )}

          {totalPages > 1 && (
            <div className="flex justify-center mt-6 md:mt-8">
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, v) => setCurrentPage(v)}
                variant="outlined"
                shape="rounded"
                size="small"
                className="pagination"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    className="mx-1 rounded-md"
                    style={{
                      color: isDarkMode ? '#c7d2fe' : '#000000',
                      borderColor: isDarkMode ? 'rgba(99,102,241,0.4)' : 'rgba(0,0,0,0.3)',
                      backgroundColor: item.selected
                        ? (isDarkMode ? 'rgb(79,70,229)' : '#1976d2')
                        : 'transparent',
                      ...(item.selected ? { color: '#ffffff' } : {}),
                    }}
                  />
                )}
              />
            </div>
          )}
        </div>
      </div>

      <AddressTooltip />
      <StatusTooltip />
      <TypeTooltip />
      <CustomerTooltip />
      <ProductTooltip />

      {openActionMenu !== null && (() => {
        const row = paginatedData.find(r => r.order_id === openActionMenu);
        if (!row) return null;
        const isPending = row.status?.toLowerCase().includes('pending');
        const isDelivered = row.status?.toLowerCase().includes('delivered');
        const isCancelled = row.status?.toLowerCase().includes('cancel');
        return createPortal(
          <div
            className="action-dropdown-menu fixed w-56 p-1.5 bg-white/95 dark:bg-[#0c0e1a]/95 backdrop-blur-xl border border-slate-200/90 dark:border-indigo-500/30 rounded-2xl shadow-[0_20px_50px_-10px_rgba(15,23,42,0.25),0_4px_16px_-4px_rgba(15,23,42,0.1)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.8),0_0_24px_rgba(99,102,241,0.25)] ring-1 ring-black/5 dark:ring-indigo-500/20 z-[999999] text-left custom-scrollbar"
            style={{ top: actionMenuPos.top, bottom: actionMenuPos.bottom, left: actionMenuPos.left, maxHeight: actionMenuPos.maxHeight, overflowY: 'auto' }}
          >
            {/* Mini Header */}
            <div className="px-2.5 py-1.5 mb-1 flex items-center justify-between border-b border-slate-100 dark:border-white/[0.08]">
              <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-400">Actions</span>
              <span className="text-[10px] font-mono font-medium text-slate-400 dark:text-indigo-300 truncate max-w-[110px]">
                #{row.order_id}
              </span>
            </div>

            <div className="space-y-0.5">
              {/* View */}
              <button
                type="button"
                onClick={() => { handleViewClick(row); setOpenActionMenu(null); }}
                className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
              >
                <div className="flex items-center gap-2.5">
                  <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-indigo-50 text-indigo-600 dark:bg-indigo-950/70 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-900/50 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                    <HiOutlineEye className="w-4 h-4" />
                  </span>
                  <span>View Details</span>
                </div>
                <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
              </button>

              {/* Clone Order */}
              <button
                type="button"
                onClick={() => { handleCloneOrder(row); setOpenActionMenu(null); }}
                className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
              >
                <div className="flex items-center gap-2.5">
                  <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-sky-50 text-sky-600 dark:bg-sky-950/70 dark:text-sky-400 border border-sky-100 dark:border-sky-900/50 group-hover:bg-sky-500 group-hover:text-white transition-all duration-150 shadow-2xs">
                    <HiOutlineDocumentDuplicate className="w-4 h-4" />
                  </span>
                  <span>Clone Order</span>
                </div>
                <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
              </button>

              {isPending ? (
                <>
                  {/* Ship Now */}
                  <button
                    type="button"
                    onClick={() => { handleShipNow(row); setOpenActionMenu(null); }}
                    className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-semibold text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50/80 dark:hover:bg-emerald-950/30 active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-gradient-to-tr from-emerald-500 to-teal-500 text-white shadow-sm shadow-emerald-500/30 group-hover:scale-105 transition-all duration-150">
                        <HiOutlineRocketLaunch className="w-4 h-4" />
                      </span>
                      <span>Ship Now</span>
                    </div>
                    <span className="px-1.5 py-0.5 text-[9px] font-bold tracking-wider uppercase rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                      Fast
                    </span>
                  </button>

                  {/* Cancel Order */}
                  <button
                    type="button"
                    onClick={() => { handleCancelOrder(row.order_id); setOpenActionMenu(null); }}
                    className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-rose-600 dark:text-rose-400 hover:bg-rose-50/80 dark:hover:bg-rose-950/30 active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-rose-50 text-rose-600 dark:bg-rose-950/70 dark:text-rose-400 border border-rose-100 dark:border-rose-900/50 group-hover:bg-rose-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                        <HiOutlineXCircle className="w-4 h-4" />
                      </span>
                      <span>Cancel Order</span>
                    </div>
                    <HiChevronRight className="w-3.5 h-3.5 text-rose-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                  </button>
                </>
              ) : (
                <>
                  {!isCancelled && (
                    <div className="pt-1 mt-1 border-t border-slate-100 dark:border-white/[0.08] space-y-0.5">
                      <button
                        type="button"
                        onClick={() => { handlePrintLabel(row.order_id); setOpenActionMenu(null); }}
                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                      >
                        <div className="flex items-center gap-2.5">
                          <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-violet-50 text-violet-600 dark:bg-violet-950/70 dark:text-violet-400 border border-violet-100 dark:border-violet-900/50 group-hover:bg-violet-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                            <HiOutlinePrinter className="w-4 h-4" />
                          </span>
                          <span>Print Label</span>
                        </div>
                        <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                      </button>
                    </div>
                  )}
                  {isDelivered && (
                    <div className="pt-1 mt-1 border-t border-slate-100 dark:border-white/[0.08] space-y-0.5">
                      <button
                        type="button"
                        onClick={() => { handleDownloadPOD(row); setOpenActionMenu(null); }}
                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                      >
                        <div className="flex items-center gap-2.5">
                          <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-teal-50 text-teal-600 dark:bg-teal-950/70 dark:text-teal-400 border border-teal-100 dark:border-teal-900/50 group-hover:bg-teal-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                            <HiOutlineDocumentText className="w-4 h-4" />
                          </span>
                          <span>Download POD</span>
                        </div>
                        <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>,
          document.body
        );
      })()}

      <ViewAllShipment
        isopen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        shipment={selectedShipment}
        wareHouseList={wareHouseList}
        fetchOrderData={fetchAllShipments}
      />
      <ViewRateForwardShipment isopen={isPopupOpenForShip} onClose={() => setIsPopupOpenForShip(false)} data={selectedShipment} />

      <TrackingSidePopup
        isOpen={isTrackingPopupOpen}
        onClose={() => setIsTrackingPopupOpen(false)}
        searchTerm={trackingSearchTerm}
        setSearchTerm={setTrackingSearchTerm}
        isDarkMode={isDarkMode}
      />

      <AddShipmentPopup
        isOpen={isAddShipmentPopupOpen}
        onClose={() => setIsAddShipmentPopupOpen(false)}
        onShipmentAdded={handleShipmentAdded}
      />

      <UploadBulk isopen={uploadBulkPopupOpen} onClose={handleCloseUploadBulk} />
    </div>
  );
};

export default AllShipment;